import React from 'react'
import DashboardPage from '../../modules/admintbk/DashboardPage'

const Dashboard = () => {
    return (
        <DashboardPage></DashboardPage>
    )
}

export default Dashboard